import { requiredRoles } from '@/shared/utils/require-roles'
import { UserRole } from '@depanneo/types'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_authenticated/org/$orgId/settings/intervention-rules'
)({
  beforeLoad() {
    requiredRoles([UserRole.ADMIN, UserRole.SUPER_ADMIN])
  },
})
